import './index.less';

import { Button, Modal, TextLink } from '@bfe/moly';
import { SecureTransactionApprovalicon } from '@bfe/moly-icons';
import { Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';
import {
  getMainDeviceBindStatus,
  MainDeviceBindStatusCode,
} from '@/services/primaryDevice';

import DisableMainDevice from './DisableMainDevice';

const MainDeviceEntry = () => {
  const [$t, lang] = useI18nContext();
  const [hasBind, setHasBind] = useState(false);
  const [visibleBindModal, setVisibleBindModal] = useState(false);
  const [visibleDisableModal, setVisibleDisableModal] = useState(false);
  const [disableLoading, setDisableLoading] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setVisibleBindModal(true);
  };

  const closeModal = () => {
    setVisibleBindModal(false);
  };

  const showDisableModal = () => {
    setDisableLoading(true);
    setVisibleDisableModal(true);
  };

  const closeDisableModal = () => {
    setVisibleDisableModal(false);
  };

  useEffect(() => {
    getMainDeviceBindStatus().then((resp) => {
      setHasBind(resp?.result?.bind_status === MainDeviceBindStatusCode.Bind);
    });
  }, []);

  return (
    <>
      <AccountBasicItem
        icon="primaryDevice"
        molyIcon={<SecureTransactionApprovalicon />}
        text={$t('mainDeviceEntryTitle')}
        subText={$t('mainDeviceEntryDesc')}
        status={hasBind}
        statusNode={<>{hasBind ? $t('Set up Tip') : $t('Not Set')}</>}
        operation={
          <>
            <Space>
              {hasBind ? (
                <>
                  <Button
                    size="small"
                    data-radius="small"
                    variant="secondary"
                    onClick={showDisableModal}
                    disabled={disableLoading}
                    loading={disableLoading}
                  >
                    {$t('Disable')}
                  </Button>
                  <Button
                    size="small"
                    data-radius="small"
                    variant="primary"
                    onClick={() => {
                      navigate('/app/user/primary-device');
                    }}
                    disabled={disableLoading}
                  >
                    {$t('View New')}
                  </Button>
                </>
              ) : (
                <Button
                  size="small"
                  data-radius="small"
                  variant={hasBind ? 'default' : 'primary'}
                  onClick={showModal}
                  disabled={disableLoading}
                >
                  {$t('Setting')}
                </Button>
              )}
            </Space>
          </>
        }
      />
      <Modal
        title={$t('notice')}
        onOk={closeModal}
        onClose={closeModal}
        size="small"
        cancelText={null}
        okText={$t('Confirm')}
        open={visibleBindModal}
        className="bind-main-device-tip-modal"
      >
        <div className="bind-main-device-tip-item">
          {$t('mainDeviceGoToAppTip')}
        </div>
        <div className="bind-main-device-tip-item">
          <TextLink
            variant="primary"
            size="normal"
            href={`/${lang}/help-center/article/How-to-Activate-Remove-Secure-Transaction-Approval`}
            closeIcon
          >
            {$t('howToSetMainDevice')}
          </TextLink>
        </div>
      </Modal>

      <DisableMainDevice
        visibleDisableModal={visibleDisableModal}
        onClose={() => {
          closeDisableModal();
          setDisableLoading(false);
        }}
        onSuccess={() => {
          setHasBind(false);
          window.location.reload();
        }}
      />
    </>
  );
};
export default MainDeviceEntry;
